"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var app_1 = require("firebase/app");
var auth_1 = require("firebase/auth");
// TODO: Replace the following with your app's Firebase project configuration
var firebaseConfig = {
    apiKey: "AIzaSyA_mFxguxKNlgaah8No7wCumEUI2ae0biw",
    authDomain: "medfyle-app.firebaseapp.com",
    databaseURL: "https://medfyle-app.firebaseio.com",
    projectId: "medfyle-app",
    storageBucket: "medfyle-app.appspot.com",
    messagingSenderId: "315604806334",
    appId: "1:315604806334:web:49b1da4426904bb322ccef",
    measurementId: "G-S7114EEXB2"
};
var app = (0, app_1.initializeApp)(firebaseConfig);
var auth = (0, auth_1.getAuth)(app);
var axios = require('axios').default;
function doEmailLogin() {
    var email_element = document.querySelector('input[name="firebase_login_email"]');
    var password_element = document.querySelector('input[name="firebase_login_password"]');
    if (!email_element || !password_element) {
        return;
    }
    var email_value = email_element.value;
    var password_value = password_element.value;
    (0, auth_1.signInWithEmailAndPassword)(auth, email_value, password_value)
        .then(function (userCredential) {
        // Signed in
        var user = userCredential.user;
        console.log('Login successful');
        user.getIdToken(/* forceRefresh */ true).then(function (idToken) {
            axios.post('/auth/firebase_check_id_token', {
                idtoken: idToken
            })
                .then(function (response) {
                var redirectToIntended = function () {
                    document.location.href = '/redirect-to-intended';
                };
                axios.get('/api/user', { params: { firetoken: idToken } })
                    .then(function (response) {
                    dataLayer.push(__assign(__assign({}, parseUserProperties({
                        user_job: response.data.job,
                        user_specialization: response.data.specialization
                    })), { 'event': 'login', 'method': 'Email' }));
                    posthog.capture('user_login', { method: 'Email' });
                })
                    .then(redirectToIntended)
                    .catch(function (reason) {
                    console.error(reason);
                    redirectToIntended();
                });
            })
                .catch(function (error) {
                alert('An error has occurred while trying to login this user on our systems.');
                console.log(error);
            });
        }).catch(function (error) {
            alert('Error while retrieving ID Token');
        });
    })
        .catch(function (error) {
        var _a, _b, _c;
        console.log('Login error');
        var errorCode = error.code;
        var errorMessage = error.message;
        console.log('Login error code:');
        console.log(errorCode);
        console.log('Login error message:');
        console.log(errorMessage);
        if (error.code === 'auth/wrong-password') {
            password_element.value = '';
            var div = document.createElement('div');
            div.innerHTML = '<strong style="color:#ff0000;">Wrong password. <a href="/password/email">Click here to reset it</a></strong>';
            var originalNode = document.querySelector('.doLogin');
            (_b = (_a = originalNode === null || originalNode === void 0 ? void 0 : originalNode.parentNode) === null || _a === void 0 ? void 0 : _a.parentNode) === null || _b === void 0 ? void 0 : _b.insertBefore(div, (_c = originalNode === null || originalNode === void 0 ? void 0 : originalNode.parentNode) === null || _c === void 0 ? void 0 : _c.nextSibling);
        }
        else {
            alert('Login error: ' + errorCode);
        }
    });
}
function doEmailRegister() {
    var email_element = document.querySelector('input[name="firebase_register_email"]');
    var password_element = document.querySelector('input[name="firebase_register_password"]');
    if (email_element != null && password_element != null) {
        var email_value = email_element.value;
        var password_value = password_element.value;
        (0, auth_1.createUserWithEmailAndPassword)(auth, email_value, password_value)
            .then(function (userCredential) {
            // Signed in
            var user = userCredential.user;
            console.log('Registration successful');
            console.log(user);
            user.getIdToken()
                .then(function (token) {
                console.log(token);
                axios.post('/auth/firebase_register_id_token', {
                    idtoken: token
                })
                    .then(function (response) {
                    console.log(response);
                    alert('Registration successful. Now you can login');
                })
                    .catch(function (error) {
                    alert('An error occurred. Please try again later.');
                    console.log(error);
                });
            });
        })
            .catch(function (error) {
            var errorCode = error.code;
            var errorMessage = error.message;
            console.log('Registration error code:');
            console.log(errorCode);
            console.log('Registration error message:');
            console.log(errorMessage);
            if (error.code == 'auth/popup-closed-by-user') {
                //
            }
            else if (error.code == 'auth/cancelled-popup-request') {
                alert('Ops! Something went wrong.\n' +
                    'If you haven\'t done it yet, please enable cookies in your browser settings.');
            }
            else {
                alert('Registration error: ' + errorCode);
            }
        });
    }
}
function doGoogleLogin() {
    console.log('Login with Google...');
    var auth = (0, auth_1.getAuth)();
    var provider = new auth_1.GoogleAuthProvider();
    (0, auth_1.signInWithPopup)(auth, provider)
        .then(function (result) {
        // This gives you a Google Access Token. You can use it to access the Google API.
        var credential = auth_1.GoogleAuthProvider.credentialFromResult(result);
        if (credential) {
            var token = credential.accessToken;
        }
        // The signed-in user info.
        var user = result.user;
        console.log('Registration successful');
        user.getIdToken()
            .then(function (token) {
            axios.post('/api/auth/firebase', { idtoken: token })
                .then(function (response) {
                var _a, _b;
                if (response.data && response.data.new_user) {
                    // if (response.data.user_id) {
                    //     _mtm.push({'uid': response.data.user_id});
                    // }
                    var userProperties = parseUserProperties(response.data);
                    dataLayer.push(__assign(__assign({}, userProperties), { 'event': 'sign_up', 'method': 'Google' }));
                    // _mtm.push({'event': 'signUp', 'identity_provider': 'google'});
                    posthog.capture('user_sign_up', {
                        method: 'Google',
                        $set_once: {
                            sign_up_method: 'Google',
                            sign_up_device: 'web',
                            initial_professional_role: (_a = userProperties.professional_role) !== null && _a !== void 0 ? _a : null,
                            initial_specialization: (_b = userProperties.specialization) !== null && _b !== void 0 ? _b : null,
                        },
                    });
                }
                if (response.data && !response.data.new_user) {
                    dataLayer.push(__assign(__assign({}, parseUserProperties(response.data)), { 'event': 'login', 'method': 'Google' }));
                    posthog.capture('user_login', { method: 'Google' });
                }
                document.location.href = '/redirect-to-intended';
            })
                .catch(function (error) {
                alert('An error occurred. Please try again later.');
                console.log(error);
            });
        });
    }).catch(function (error) {
        var errorCode = error.code;
        var errorMessage = error.message;
        console.log('Registration error code:');
        console.log(errorCode);
        console.log('Registration error message:');
        console.log(errorMessage);
        if (error.code == 'auth/popup-closed-by-user') {
            //
        }
        else if (error.code == 'auth/cancelled-popup-request') {
            alert('Ops! Something went wrong.\n' +
                'If you haven\'t done it yet, please enable cookies in your browser settings.');
        }
        else {
            alert('Registration error: ' + errorCode);
        }
    });
}
function doFacebookLogin() {
    console.log('Login with Facebook...');
    var auth = (0, auth_1.getAuth)();
    var provider = new auth_1.FacebookAuthProvider();
    (0, auth_1.signInWithPopup)(auth, provider)
        .then(function (result) {
        var credential = auth_1.FacebookAuthProvider.credentialFromResult(result);
        if (credential) {
            var token = credential.accessToken;
        }
        // The signed-in user info.
        var user = result.user;
        console.log('Registration successful');
        user.getIdToken()
            .then(function (token) {
            axios.post('/api/auth/firebase', { idtoken: token })
                .then(function (response) {
                var _a, _b;
                if (response.data && response.data.new_user) {
                    // if (response.data.user_id) {
                    //     _mtm.push({'uid': response.data.user_id});
                    // }
                    var userProperties = parseUserProperties(response.data);
                    dataLayer.push(__assign(__assign({}, userProperties), { 'event': 'sign_up', 'method': 'Facebook' }));
                    // _mtm.push({'event': 'signUp', 'identity_provider': 'facebook'});
                    posthog.capture('user_sign_up', {
                        method: 'Facebook',
                        $set_once: {
                            sign_up_method: 'Facebook',
                            sign_up_device: 'web',
                            initial_professional_role: (_a = userProperties.professional_role) !== null && _a !== void 0 ? _a : null,
                            initial_specialization: (_b = userProperties.specialization) !== null && _b !== void 0 ? _b : null,
                        },
                    });
                }
                if (response.data && !response.data.new_user) {
                    dataLayer.push(__assign(__assign({}, parseUserProperties(response.data)), { 'event': 'login', 'method': 'Facebook' }));
                    posthog.capture('user_login', { method: 'Facebook' });
                }
                document.location.href = '/redirect-to-intended';
            })
                .catch(function (error) {
                alert('An error occurred. Please try again later.');
                console.log(error);
            });
        });
    }).catch(function (error) {
        var errorCode = error.code;
        var errorMessage = error.message;
        console.log('Registration error code:');
        console.log(errorCode);
        console.log('Registration error message:');
        console.log(errorMessage);
        if (error.code == 'auth/popup-closed-by-user') {
            //
        }
        else if (error.code == 'auth/cancelled-popup-request') {
            alert('Ops! Something went wrong.\n' +
                'If you haven\'t done it yet, please enable cookies in your browser settings.');
        }
        else {
            alert('Registration error: ' + errorCode);
        }
    });
}
function doEmailRegisterProduction() {
    var email_element = document.querySelector('input[name="firebase_register_email"]');
    var password_element = document.querySelector('input[name="firebase_register_password"]');
    if (email_element != null && password_element != null) {
        var email_value = email_element.value;
        var password_value = password_element.value;
        (0, auth_1.createUserWithEmailAndPassword)(auth, email_value, password_value)
            .then(function (userCredential) {
            // Signed in
            var user = userCredential.user;
            console.log('Registration successful');
            console.log(user);
            user.getIdToken()
                .then(function (token) {
                console.log(token);
                axios.post('/auth/firebase_register_id_token', {
                    idtoken: token
                })
                    .then(function (response) {
                    console.log(response);
                    alert('Registration successful. Now you can login');
                })
                    .catch(function (error) {
                    alert('An error occurred. Please try again later.');
                    console.log(error);
                });
            });
        })
            .catch(function (error) {
            var errorCode = error.code;
            var errorMessage = error.message;
            console.log('Registration error code:');
            console.log(errorCode);
            console.log('Registration error message:');
            console.log(errorMessage);
            if (error.code == 'auth/popup-closed-by-user') {
                //
            }
            else if (error.code == 'auth/cancelled-popup-request') {
                alert('Ops! Something went wrong.\n' +
                    'If you haven\'t done it yet, please enable cookies in your browser settings.');
            }
            else {
                alert('Registration error: ' + errorCode);
            }
        });
    }
}
function sendResetPasswordEmail(email) {
    var auth = (0, auth_1.getAuth)();
    var actionCodeSettings = {
        // After password reset, the user will be give the ability to go back
        // to this page.
        url: 'https://medfyle.com/auth/login',
        handleCodeInApp: false
    };
    (0, auth_1.sendPasswordResetEmail)(auth, email, actionCodeSettings)
        .then(function () {
        alert('You will receive an email with instructions to reset your password');
    })
        .catch(function (error) {
        var errorCode = error.code;
        var errorMessage = error.message;
        alert('Error ' + error.code + ': ' + error.message);
    });
}
var loginButton = document.querySelector('button.doLogin');
if (loginButton != null) {
    loginButton.addEventListener('click', doEmailLogin);
}
var loginForm = document.querySelector('.js-login-form');
if (loginForm) {
    loginForm.addEventListener('submit', function (e) {
        e.preventDefault();
        doEmailLogin();
    });
}
var registerButton = document.querySelector('button.doRegister');
if (registerButton != null) {
    registerButton.addEventListener('click', doEmailRegister);
}
var socialLoginButtonGoogle = document.querySelector('button.google-btn');
if (socialLoginButtonGoogle != null) {
    socialLoginButtonGoogle.addEventListener('click', doGoogleLogin);
}
var socialLoginButtonFacebook = document.querySelector('button.facebook-btn');
if (socialLoginButtonFacebook != null) {
    socialLoginButtonFacebook.addEventListener('click', doFacebookLogin);
}
var resetPasswordButton = document.querySelector('button.btn-send-reset-link');
var mailField = document.querySelector('input.field_mail');
if (resetPasswordButton != null && mailField != null) {
    resetPasswordButton.addEventListener('click', function () {
        sendResetPasswordEmail(mailField.value);
    });
}
var resetPasswordForm = document.querySelector('.js-reset-password-form');
if (resetPasswordForm && mailField) {
    resetPasswordForm.addEventListener('submit', function (e) {
        e.preventDefault();
        sendResetPasswordEmail(mailField.value);
    });
}
function parseUserProperties(data) {
    var _a;
    var userProperties = {};
    var jobExists = typeof data.user_job !== 'undefined' && data.user_job;
    if (jobExists) {
        userProperties = __assign(__assign({}, userProperties), { 'professional_role': data.user_job });
    }
    var specialization = (_a = data.user_specialization) !== null && _a !== void 0 ? _a : null;
    if (jobExists || specialization) {
        userProperties = __assign(__assign({}, userProperties), { 'specialization': specialization });
    }
    return userProperties;
}
